import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import camelCase from 'lodash/camelCase';
import { type PackagePickerStoreSlice } from '../../../../../../../redux/packagePicker/types';
import { CoreTypes } from '../../../../../types';

import s from './BenefitsList.scss';

interface Props {
  coreType: CoreTypes;
  isOpen: boolean;
  referer: string;
  packageBenefits: PackagePickerStoreSlice['packageBenefits'];
}

const BenefitsList: FC<Props> = ({ coreType, isOpen, packageBenefits }) => {
  const { t } = useTranslation();
  const coreTypeCamelCased = camelCase(coreType);
  const firstBenefit = packageBenefits?.[0]?.benefits?.[0]?.values?.[coreTypeCamelCased];

  return isOpen ? (
    <div className={s['benefits']}>
      {packageBenefits?.map(({ benefits }, index) => (
        <div key={index}>
          {benefits.map(({ title, values }, benefitIndex) => {
            const { label, sublabel, labelType } = values?.[coreTypeCamelCased] ?? {};
            if (labelType !== 'text') {
              return null;
            }
            if (label.replace(/[ -]/g, '').length === 0) {
              return null;
            }
            return (
              <div key={benefitIndex} className={s['benefits-item']}>
                <div className={s['benefits-label']}>{label}</div>
                {sublabel && <div className={s['benefits-sublabel']}>{sublabel}</div>}
              </div>
            );
          })}
        </div>
      ))}

      <div className={s['benefits-item']}>
        <div className={s['desktop-info']}>
          {t(`packagePicker.heroTable.benefits.mobile.desktopInfo`)}
          <div className={s['benefits-sublabel']}>
            {t(`packagePicker.heroTable.benefits.mobile.thirdPartyProcessing`)}
          </div>
        </div>
      </div>
    </div>
  ) : (
    firstBenefit && (
      <div className={s['benefits-folded']}>
        <div className={s['benefits-item']}>
          <h4>{firstBenefit?.label}</h4>
        </div>
      </div>
    )
  );
};
BenefitsList.displayName = 'BenefitsList';

export default BenefitsList;
